(ns kyber.kyber-db.question-context)

(def model
  {:ident-key
   :question.context/uuid

   :refs
   {:question.context/question
    {:model :question
     :cardinality :one}

    :question.context/learning-objective
    {:model :learning-objective
     :cardinality :one}

    :question.context/resources
    {:model :activity-resource
     :cardinality :many}}

   :schema
   #:question.context
   {:uuid
    {:doc "UUID of the question context object"}

    :assessment-type
    {:doc ""}

    :confidence-enabled?
    {:doc ""}

    :is-required?
    {:doc ""}}})
